import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { MessageService } from 'primeng';
import { Message } from '../../classes/Message';
import { JobsDeploymentService } from '../../services';
import { JobsService } from '../../services';
import { IOrderInfo } from '../../interfaces/task-info';

@Component({
  selector: 'ec-match-details',
  templateUrl: 'ec-match-details.component.html',
  styleUrls: ['ec-match-details.component.css'],
})
export class ECMatchDetailsComponent implements OnInit {
  constructor(
    private jobService: JobsService,
    public messageService: MessageService,
    private jobDeploymentService: JobsDeploymentService,
  ) {}

  @Input() matchIndex: number;

  _ecJob: any;
  @Input('ecJob')
  set ecJob(value: any) {
    this._ecJob = value;
    //console.log("EC Job set in ec-matches-details component: ", this._ecJob);
  }
  get ecJob(): any {
    return this._ecJob;
  }

  _supplierOrderInfo: IOrderInfo;

  _supplierJob: any;
  @Input('supplierJob')
  set supplierJob(value: any) {
    this._supplierJob = value;

    console.log('Supplier job: ', this._supplierJob);
    this.supplierData = this._supplierJob.supplier;
    this.supplierOrder = this.convertToOrderInfo(this._supplierJob);
  }
  get supplierJob(): any {
    return this._supplierJob;
  }

  supplierData: any;
  supplierOrder: any;

  smsText: string = '';
  public allocateItem: any = {};
  public showAllocateJobDialog: boolean = false;

  ngOnInit() {
    let earliestTask = this.ecJob.tasks[0];
    let pickup = earliestTask.pickupLocation != null ? earliestTask.pickupLocation.city : '';
    let dropoff = earliestTask.dropoffLocation != null ? earliestTask.dropoffLocation.city : '';

    //console.log("Earliest task: ", earliestTask);
    //console.log("Initialised ec match details component");

    this.smsText = `Dear [Supplier], New jobs available in your area ${earliestTask.pickupEarliestDateTime}: ${pickup} - ${dropoff}, please check the Engineius mobile app inbox`;
  }

  convertToOrderInfo(supplierJob) {
    //console.log("Converting job to orderInfo: ", supplierJob);

    // compress orders/tasks into IOrderInfo object
    let o: IOrderInfo;
    for (var i = 0; i < supplierJob.orders.length; i++) {
      if (o) o.tasks = o.tasks.concat(supplierJob.orders[i].tasks);
      else o = supplierJob.orders[i];

      o.jobNumber = supplierJob.jobNumber;
      o.jobId = supplierJob.id;
      o.supplierPrice = supplierJob.supplierPrice;
    }

    //console.log("Converted job to orderInfo: ", o);
    return o;
  }

  taskClick(event) {
    console.log('Task clicked: ', event);
  }

  directToSupplier() {
    this.jobService
      .changeSupplierDetails({
        jobId: this.ecJob.jobId,
        eRegionIds: [],
        supplierIds: [this.supplierData.id],
        smsText: this.smsText,
      })
      .then((x) => {
        this.messageService.add(
          Message.Success('Supplier directed to job.', 'Change Supplier Price/Account'),
        );
      })
      .catch((x) => {
        this.messageService.add(
          Message.Error(
            'An error occurred while trying to modify the data. Try again. If the error persists, contact your administrator.',
            'Change Supplier Details',
          ),
        );
      });
  }

  allocateToSupplier() {
    this.allocateItem = {
      jobId: this.ecJob.jobId,
      supplierId: this.supplierData.id,
      price: this.ecJob.buyItNowPrice,
    };

    console.log('Created allocation item: ', this.allocateItem);

    this.showAllocateJobDialog = true;
  }

  public allocateToSupplierSave(item) {
    this.jobDeploymentService
      .allocateJob(item)
      .then((res) => {
        this.showAllocateJobDialog = false;

        // refresh EC Matches since this one has been allocated

        // raise event so job tabs can be reloaded
      })
      .catch((err) => {
        this.showAllocateJobDialog = false;
        if (err.error && err.error.Message) {
          this.messageService.add(Message.Error(`${err.error.Message}`, 'Allocate Job'));
        } else {
          this.messageService.add(
            Message.Error(
              `An error occurred when trying to allocate job to Supplier`,
              'Allocate Job',
            ),
          );
        }
      });
  }
}
